import React, { useEffect } from 'react';
import { HeroSection } from '../components/HeroSection';
import { OpeningHook } from '../components/OpeningHook';
import { ProblemSection } from '../components/ProblemSection';
import { FailedSolutions } from '../components/FailedSolutions';
import { UniqueMechanism } from '../components/UniqueMechanism';
import { WhatYouGet } from '../components/WhatYouGet';
import { WhoIsFor } from '../components/WhoIsFor';
import { ProofSection } from '../components/ProofSection';
import { FAQSection } from '../components/FAQSection';
import { OfferBlock } from '../components/OfferBlock';
import { Footer } from '../components/Footer';
import { SocialProofPopup } from '../components/SocialProofPopup';
import { initMetaPixel } from '../utils/metaPixel';
export function SalesPage() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <main className="min-h-screen bg-navy-gradient selection:bg-gold-400/30 selection:text-white" data-id="element-208">
      <HeroSection data-id="element-209" />
      <OpeningHook data-id="element-210" />
      <ProblemSection data-id="element-211" />
      <FailedSolutions data-id="element-212" />
      <UniqueMechanism data-id="element-213" />
      <WhatYouGet data-id="element-214" />
      <WhoIsFor data-id="element-215" />
      <ProofSection data-id="element-216" />
      <FAQSection data-id="element-217" />
      <OfferBlock data-id="element-218" />

      <Footer data-id="element-219" />
      <SocialProofPopup data-id="element-220" />
    </main>;
}